import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit } from 'react-icons-kit/md';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Create from "./models/CreatePhone";
import ConfirmDelete from "./models/ConfirmDelete";
import Edit from "./models/EditPhone";
import {
  PHONE_REQUEST,
  PHONE_CREATE,
  PHONE_DELETE,
  PHONE_EDIT,
  PHONE_STATE_CHANGE,

} from "../../../../_utils/constants/ProductCatalog";

import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Phone = ({
  auth: { auth, isAuthenticated },
  Phone: { valueList, isCreated, isDeleted, isEdited, isLoading },

  fetchPhone,
  submitPhoneCreate,
  submitPhoneDelete,
  submitPhoneEdit,
  changeReducerState,

}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [salesPhoneName, setPhoneName] = useState('');
  const [sortOrder, setSortOrder] = useState("");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [deletePhoneId, setDeletePhoneId] = useState('');
  const [show, setShow] = useState(false);
  const [ids, setIds] = useState("");
  const [state, setState] = useState({
    "phoneType": "",
    "areaCode": "",
    "phoneNumber": "",
    "extension": "",
    "phoneDetailFor": "",
    "contactPersonId": "",
  }
  )
  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchPhone(auth[0].token);
    }
  }, [auth, isAuthenticated]);



  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("Phone Created Successfully.");
      fetchPhone(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("Phone Deleted Successfully.");
      fetchPhone(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("Phone Data Updated Successfully.");
      fetchPhone(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);


  const handleChange = (e) => {
    const { id, value } = e.target;
    setState({ ...state, [id]: value })

  }

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
    setShow(false)
    setIds("");
    setState({
      "phoneType": "",
      "areaCode": "",
      "phoneNumber": "",
      "extension": "",
      "phoneDetailFor": "",
      "contactPersonId": "",

    })
  };

  // function called for input value change of create modal
  const handleSalesStageNameChange = (e) => {
    setPhoneName(e.target.value);
  }
  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
  }

  // function called for create sales stage create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (state.phoneType === '') {
      toast.error("PhoneType cannot be empty.");
    } else {
      submitPhoneCreate({
        "data": {
          "PhoneType": state.phoneType,
          "AreaCode": state.areaCode,
          "PhoneNumber": state.phoneNumber,
          "Extension": state.extension,
          "PhoneDetailFor": state.phoneDetailFor,
          "ContactPersonId": parseInt(state.contactPersonId),
          "CreatedBy": auth[0].userId,
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeletePhoneId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeletePhoneId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete sales stage delete api
  const handleConfirmDeleteSubmit = () => {
    submitPhoneDelete({
      "PhoneId": deletePhoneId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setState(data);
    setIds(data.phoneId);
    setShow(true)
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (state.phoneType === '') {
      toast.error("PhoneType cannot be empty.");
    } else {
      submitPhoneEdit({
        "data": {
          "PhoneId": ids,
          "PhoneType": state.phoneType,
          "AreaCode": state.areaCode,
          "PhoneNumber": state.phoneNumber,
          "Extension": state.extension,
          "PhoneDetailFor": state.phoneDetailFor,
          "ContactPersonId": parseInt(state.contactPersonId),
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>Phone</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`Phone`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              salesStageName={salesPhoneName}
              handleSalesStageNameChange={handleSalesStageNameChange}
              sortOrder={sortOrder}
              handleSortOrderChange={handleSortOrderChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
              handleChange={handleChange}
              state={state}

            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>PhoneType</th>
                <th className="text-center">Area Code</th>
                <th width="50" className="actions">
                  <div className="d-flex">
                    <span>Edit</span>
                    <span>Delete</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (

                  <tr key={index}>
                    <td>
                      {item.phoneType}
                    </td>
                    <td width="150">
                      {item.areaCode}
                    </td>
                    <td className="actions">
                      <div className="btn-group">
                        <Icon role="button" className="mt-2 w-54 d-flex justify-content-center" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                        <ConfirmDelete variant="primary" title={`Phone`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.phoneId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                      </div>
                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
      <Edit
        state={state}
        handleChange={handleChange}
        handleEditSaveClick={handleEditSaveClick}
        show={show}
        hideCreateModal={hideCreateModal}
        title={`Phone`}
      />
    </MainWrapper>
  )
}

const mapStateToProps = ({ auth, Phone }) => {
  return {
    auth,
    Phone,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {

    fetchPhone: (token) => dispatch({ type: PHONE_REQUEST, token }),
    submitPhoneCreate: (data) => dispatch({ type: PHONE_CREATE, payload: data }),
    submitPhoneDelete: (data) => dispatch({ type: PHONE_DELETE, payload: data }),
    submitPhoneEdit: (data) => dispatch({ type: PHONE_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: PHONE_STATE_CHANGE }),


  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Phone);